import { Routes, Route } from '@angular/router';

import { authenticationGuard } from '@core/guards';
import { MainComponent } from '../containers/main/main.component';

export const MainShell = {
  /**
   * Creates routes using the main shell component with authentication.
   *
   * @param routes The routes to add.
   * @return The new route using shell auth as the base.
   */
  childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: MainComponent,
      children: routes,
      canActivate: [authenticationGuard],
    };
  },
};
